/** REVIEW: 未レビュー */
import { defineStore } from 'pinia';

import {
  ShopDetailResponse,
  ShopRepository,
} from '@/repositories/generated';
import { toPostalCodeWithHyphen } from '@/utils';
import { ShopEditForm } from '@/validations/shop';

type TEditShopState = {
  form: ShopEditForm | undefined;
  initData: ShopDetailResponse | undefined;
};

export const useEditShopStore = defineStore('editShop', {
  state: (): TEditShopState => ({
    form: undefined,
    initData: undefined,
  }),
  actions: {
    // eslint-disable-next-line complexity
    async editShop() {
      const {
        form,
        initData,
      } = this;

      if (!(form && initData)) return;

      await ShopRepository.edit({
        id: initData.id,
        requestBody: {
          ...form,
          companyId: initData.shopDetailBasicInfo.companyResponse.id,
          contractStoreId: form.contractStoreId || undefined,
          externalId: form.externalId ?? '',
          homepageUrl: form.homepageUrl || null,
          lastUpdatedAt: initData.shopDetailBasicInfo.updatedAt,
          latitude: form.latitude ?? undefined,
          longitude: form.longitude ?? undefined,
          maxSettlementAmount: form.maxSettlementAmount ?? undefined,
          name: form.name ?? '',
          phone: form.phone ?? '',
          buildingName: form.buildingName || null,
          postalCode: toPostalCodeWithHyphen(form.postalCode) ?? '',
          shopStartDate: form.shopStartDate.toISOString(),
          shopEndDate: form.shopEndDate?.toISOString(),
          remarks: form.remarks || null,
          nameKana: form.nameKana || null,
          nameRomaji: form.nameRomaji || null,
          merchantCategoryCode: form.merchantCategoryCode || null,
          shopCustomField1: form.shopCustomField1 || null,
          shopCustomField2: form.shopCustomField2 || null,
          shopCustomField3: form.shopCustomField3 || null,
          shopCustomField4: form.shopCustomField4 || null,
          shopCustomField5: form.shopCustomField5 || null,
          paymentCompletionEmail: form.paymentCompletionEmail || null,
          shopSettlementSetting: form.shopSettlementSetting.map((it) => ({
            creditFeeRatio: it.creditFeeRatio ?? 0,
            directBankFeeRatio: it.directBankFeeRatio ?? 0,
            prepaidChargeFeeRatio: it.prepaidChargeFeeRatio ?? 0,
            prepaidSettlementFeeRatio: it.prepaidSettlementFeeRatio ?? 0,
            pspGmoShopId: it.pspGmoShopId,
            pspGmoShopPassword: it.pspGmoShopPassword,
            shopSettlementServiceEndDate: it.shopSettlementServiceEndDate?.toISOString(),
            shopSettlementServiceStartDate: it.shopSettlementServiceStartDate.toISOString(),
            walletServiceSettlementSettingId: it.walletServiceSettlementSettingId,
            housePrepaidFeeRatio: it.housePrepaidFeeRatio === '' ? null : (it.housePrepaidFeeRatio ?? null),
            digitalVoucherFeeRatio: it.digitalVoucherFeeRatio === '' ? null : (it.digitalVoucherFeeRatio ?? null),
          })),
        },
      });
    },
    async setInitData(id: string) {
      this.$reset();

      const response = await ShopRepository.detail({ id });
      this.initData = response;
    },
    setUiForm(form: ShopEditForm) {
      this.form = { ...form };
    },
    $resetForm() {
      this.form = undefined;
    },
  },
});
